<template>
    <div v-if="can('reports.transporter')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/sales" tag="li" class="breadcrumb-item"><a href="">Продажи</a></router-link>
                <router-link to="/transporter-reports" tag="li" class="breadcrumb-item"><a href="">Отчеты по перевозчикам</a></router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <div class="row">
                    <div class="col-sm-8">
                        <h1 class="title">Отчеты по перевозчикам</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_main">
            <nav>
                <div class="nav nav-tabs" id="nav-tab01" role="tablist">
                    <a class="nav-item nav-link active" id="nav-01-tab01" data-toggle="tab" href="#nav-01-1" role="tab"
                       aria-controls="nav-01-1" aria-selected="true">Реестр кассовых ведомостей</a>
                    <a class="nav-item nav-link" id="nav-02-tab02" data-toggle="tab" href="#nav-02-1" role="tab"
                       aria-controls="nav-02-1">Взаиморассчеты с перевозчиками</a>
                    <a class="nav-item nav-link" id="nav-03-tab03" data-toggle="tab" href="#nav-03-1" role="tab"
                       aria-controls="nav-03-1">Ежедневные отчеты</a>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent01">

                <div class="tab-pane fade show active" id="nav-01-1" role="tabpanel" aria-labelledby="nav-01-tab">
                    <div class="row m-3">
                        <div class="button-group">
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportMonthly(1)">{{i18n('Generate month report')}}</button>
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportDaily(1)">{{i18n('Generate daily report')}}</button>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-sm-3 px-0">
                            <div class="form-inline">
                                <model-list-select :list="transporters"
                                                   :class="'ml-3'"
                                                   v-model="selectedTransporter"
                                                   option-value="id"
                                                   option-text="name" class="w-75"
                                                   :placeholder="i18n('Transporters')">
                                </model-list-select>
                                <a href="#" class="btn">
                                    <i class="mdi mdi-close ml-1" v-if="selectedTransporter !== null"
                                       @click.prevent="selectedTransporter = null"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('Filter by date from')}}</label>
                                <datepicker
                                        v-model="fromDate"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date w-75">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('by')}}</label>
                                <datepicker
                                        v-model="toDate"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="button-group">
                                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                        @click="getTrips()">
                                    <span class="">{{i18n('To form')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive" id="table1">
                        <table class="table table-striped table-hover mb-0">
                            <thead class="text-center">
                            <tr>
                                <th scope="col" rowspan="2">{{i18n('Departure date')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Departure time')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Route Name')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Number of passengers')}}</th>
                                <th scope="col" colspan="3">{{i18n('Amount')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Total amount')}}</th>
                                <!--<th scope="col" rowspan="2">Страх{{i18n('Sa')}}ор</th>-->
                                <th scope="col" rowspan="2">{{i18n('Baggage')}}</th>
                                <th scope="col" rowspan="2">{{i18n('FULL NAME')}} водителя</th> <!--alx-->
                                <th scope="col" rowspan="2">{{i18n('Number bus')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Stations')}}</th>
                            </tr>
                            <tr>
                                <th scope="col">Нал</th>
                                <th scope="col">Терм</th>
                                <th scope="col">Онлайн</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="report in reports">
                                <td>{{report.trip_time | moment('YYYY-MM-DD')}}</td>
                                <td>{{report.trip_time | moment('HH:mm')}}</td>
                                <td>{{report.route_name}}</td>
                                <td>{{report.passengers_count}}</td>
                                <td>{{report.cash_amount}}</td>
                                <td>{{report.terminal_amount}}</td>
                                <td>{{report.online_amount}}</td>
                                <td>{{report.total_amount}}</td>
                                <!--<td>{{report.insurance}}</td>-->
                                <td>{{report.baggage_count}}</td>
                                <td>{{report.driver_name}}</td>
                                <td>{{report.bus_number}}</td>
                                <td>
                                        <button @click="getStantions(report.trip_id)" type="button"
                                                data-toggle="modal"
                                                data-target="#tripStationsModal" class="btn-icon">
                                            <i class="mdi mdi-eye text-primary"></i>
                                        </button>
                                </td>
                            </tr>
                            <tr v-if="reports.length > 0">
                                <td><b>{{i18n('Total')}}: </b></td>
                                <td>-</td>
                                <td>{{reportsOneTotal.tripsCount}}</td>
                                <td>{{reportsOneTotal.passengers}}</td>
                                <td>{{reportsOneTotal.amount}}</td>
                                <td>{{reportsOneTotal.terminalamount}}</td>
                                <td>{{reportsOneTotal.onlineamount}}</td>
                                <td>{{reportsOneTotal.totalamount}}</td>
                                <!--<td>{{reportsOneTotal.insurance}}</td>-->
                                <td>{{reportsOneTotal.baggage}}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                        <button @click="getStantionsTotal()" type="button"
                                                data-toggle="modal"
                                                data-target="#tripStationsModal" class="btn-icon">
                                            <i class="mdi mdi-eye text-primary"></i>
                                        </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-show="!loading_states.list && reports.length === 0"
                             class="text-center pt-3 pb-3 border">
                            Нет данных
                        </div>
                        <div v-show="loading_states.list" class="text-center pt-3 pb-3 border">
                            <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}...
                        </div>
                    </div>
                    <div v-if="reports.length > 0" class="base_box_cnt">
                        <div class="button-group">
                            <button type="button" class="btn base_btn waves-effect waves-light"
                                    @click="downloadXlsForOne">
                                {{i18n('Export to Excel')}}
                            </button>
                            <button type="button" class="btn base_btn waves-effect waves-light"
                                    @click="downloadStationsXlsForOne">
                                {{i18n('Stations')}} {{i18n('Export to Excel')}}
                            </button>
                            <button type="button" class="btn base_btn waves-effect waves-light"
                                    @click="printData('table1')">{{i18n('Print out')}}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-02-1" role="tabpanel" aria-labelledby="nav-02-tab02">
                    <div class="row m-3">
                        <div class="button-group">
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportMonthly">{{i18n('Generate month report')}}</button>
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportDaily(2)">{{i18n('Generate daily report')}}</button>
                        </div>
                    </div>
                    <div class="row m-3">
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('Filter by date from')}}</label>
                                <datepicker
                                        v-model="fromDateForAll"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('by')}}</label>
                                <datepicker
                                        v-model="toDateForAll"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-6 px-0">
                            <div class="button-group">
                                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                        @click="getTransporterReports()">
                                    <span class="">{{i18n('To form')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="responsive-table">
                        <div id="table">
                            <table class="table table-bordered table-striped table-hover mb-0 table-small"
                                   ref="printTable">
                                <thead class="text-center">
                                <tr>
                                    <th scope="col" rowspan="3">{{i18n('Transporter')}}</th>
                                    <th scope="col" colspan="7">Реализ. билетов</th>
                                    <th scope="col" rowspan="2" colspan="3">{{i18n('Amount')}}</th>
                                    <th scope="col" rowspan="2" colspan="3">Причитается за пасс. бил</th>
                                    <th scope="col" rowspan="2" colspan="3">Причитается за багаж</th>
                                    <th scope="col" rowspan="3">{{i18n('Bus station collection')}}</th>
                                    <th scope="col" rowspan="3">{{i18n('Bus station services')}}</th>
                                </tr>
                                <tr>
                                    <th scope="col" colspan="2">Все</th>
                                    <th scope="col" colspan="2">Предварительно проданные</th>
                                    <th scope="col" colspan="2">Проданные на текущую дату</th>
                                    <th scope="col" rowspan="2">багаж сумма</th>
                                </tr>
                                <tr>
                                    <th scope="col">кол</th>
                                    <th scope="col">{{i18n('amount')}}</th>

                                    <th scope="col">кол</th>
                                    <th scope="col">{{i18n('amount')}}</th>

                                    <th scope="col">кол</th>
                                    <th scope="col">{{i18n('amount')}}</th>

                                    <th scope="col">Нал</th>
                                    <th scope="col">Терм</th>
                                    <th scope="col">Онлайн</th>
                                    <th scope="col">% АТП</th>
                                    <th scope="col">АТП</th>
                                    <th scope="col">А/В</th>
                                    <th scope="col">% АТП</th>
                                    <th scope="col">АТП</th>
                                    <th scope="col">А/В</th>
                                </tr>
                                </thead>
                                <tbody v-if="reportsAll.length > 0">
                                <tr v-for="item in reportsAll">
                                    <td>{{item.transporter_name|moneyFormat}}</td>
                                    <td>{{item.passenger_count|moneyFormat}}</td>
                                    <td>{{item.total_amount|moneyFormat}}</td>
                                      <td>{{item.presale_passenger_count|moneyFormat}}</td>
                                      <td>{{item.presale_amount|moneyFormat}}</td>
                                      <td>{{item.today_passenger_count|moneyFormat}}</td>
                                      <td>{{item.today_amount|moneyFormat}}</td>
                                    <td>{{item.baggage_amount|moneyFormat}}</td>
                                    <td>{{item.cash_amount|moneyFormat}}</td>
                                    <td>{{item.terminal_amount|moneyFormat}}</td>
                                    <td>{{item.online_amount|moneyFormat}}</td>
                                    <td>{{item.transporter_percent|moneyFormat}}</td>
                                    <td>{{item.tp_amount|moneyFormat}}</td>
                                    <td>{{item.av_amount|moneyFormat}}</td>
                                    <td>{{item.transporter_baggage_percent|moneyFormat}}</td>
                                    <td>{{item.tp_baggage_amount|moneyFormat}}</td>
                                    <td>{{item.av_baggage_amount|moneyFormat}}</td>
                                    <td>{{item.tax|moneyFormat}}</td>
                                    <td>{{item.av_service_amount}}</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><b>{{i18n('Total')}}: </b></td>
                                    <td>{{reportsAllTotal.total_passengers|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_sum|moneyFormat}}</td>

                                    <td>{{reportsAllTotal.total_presale_passengers|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.presale_total_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_today_passengers|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.today_total_sum|moneyFormat}}</td>

                                    <td>{{reportsAllTotal.total_bag_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_cash_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_term_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_online_sum|moneyFormat}}</td>
                                    <td></td>
                                    <td>{{reportsAllTotal.total_tr_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_av_sum|moneyFormat}}</td>
                                    <td></td>
                                    <td>{{reportsAllTotal.total_tr_bag|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_av_bag|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_tax_sum|moneyFormat}}</td>
                                    <td>{{reportsAllTotal.total_service_sum|moneyFormat}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-show="loading_states.list" class="text-center pt-3 pb-3 border">
                            <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}
                        </div>
                        <div v-show="!loading_states.list && reportsAll.length === 0"
                             class="text-center pt-3 pb-3 border">
                            Нет данных
                        </div>
                        <div v-if="reportsAll.length > 0" class="base_box_cnt">
                            <div class="button-group">
                                <button type="button" class="btn base_btn waves-effect waves-light"
                                        @click="downloadXlsForAll">
                                    {{i18n('Export to Excel')}}
                                </button>
                                <button type="button" class="btn base_btn waves-effect waves-light"
                                        @click="printData('table')">{{i18n('Print out')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-03-1" role="tabpanel" aria-labelledby="nav-03-tab03">
                    <div class="row m-3">
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('Filter by date from')}}</label>
                                <datepicker
                                        v-model="dateForDaily"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-6 px-0">
                            <div class="button-group">
                                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                        @click="getTransporterDailyReports()">
                                    <span class="">{{i18n('To form')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="responsive-table">
                        <div id="table3">
                            <table class="table table-bordered table-striped table-hover mb-0 table-small" ref="printTable">
                                <thead class="text-center">
                                    <tr>
                                        <th scope="col" rowspan="2">{{i18n('Transporter')}}</th>
                                        <th scope="col" rowspan="2">{{i18n('Route')}}</th>
                                        <th scope="col" rowspan="2">{{i18n('Distance')}}</th>
                                        <th scope="col" colspan="2">{{i18n('Departure time')}}</th>
                                        <th scope="col" colspan="3">{{i18n('Bus seats')}}</th>
                                        <th scope="col" rowspan="2">{{i18n('amount')}}</th>
                                        <th scope="col" colspan="2">{{i18n('For today')}}</th>
                                        <th scope="col" colspan="2">{{i18n('Returns')}}</th>
                                        <th scope="col" colspan="2">{{i18n('Presale')}}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col" rowspan="1">{{i18n('Estimated')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('Actual')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('count')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('Tickets')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('%')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('count')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('amount')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('count')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('amount')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('count')}}</th>
                                        <th scope="col" rowspan="1">{{i18n('amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody v-if="reportsDaily.length > 0">
                                    <tr v-for="item in reportsDaily">
                                        <td>{{ item.transporter_name }}</td>
                                        <td>{{ item.route_name }}</td>
                                        <td>{{ item.distance }}</td>
                                        <td>{{ item.etd | moment('HH:mm') }}</td>
                                        <td>{{ item.atd | moment('HH:mm') }}</td>
                                        <td>{{ item.seats }}</td>
                                        <td>{{ item.passengers }}</td>
                                        <td>{{ percentFrom(item.seats, item.passengers) }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.today_count }}</td>
                                        <td>{{ item.today_amount }}</td>
                                        <td>{{ item.reversed_count }}</td>
                                        <td>{{ item.reversed_amount }}</td>
                                        <td>{{ item.presale_count }}</td>
                                        <td>{{ item.presale_amount }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-show="loading_states.list" class="text-center pt-3 pb-3 border">
                            <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}
                        </div>
                        <div v-show="!loading_states.list && reportsDaily.length === 0"
                             class="text-center pt-3 pb-3 border">
                            Нет данных
                        </div>
                        <div v-if="reportsDaily.length > 0" class="base_box_cnt">
                            <div class="button-group">
                                <button type="button" class="btn base_btn waves-effect waves-light"
                                        @click="downloadDailyReport">
                                    {{i18n('Export to Excel')}}
                                </button>
                                <button type="button" class="btn base_btn waves-effect waves-light"
                                        @click="printData('table')">{{i18n('Print out')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="tripStationsModal" tabindex="-1" role="dialog" aria-labelledby="tripStationsModalLabel"
             aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered" style="max-width: 90%;" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tripStationsModalLabel">
                            {{i18n('Stations')}}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="modalCloser2">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="base_box_ttl">
                        <h1 class="mb-0 font-weight-normal">
                            {{i18n('Stations')}}
                        </h1>
                    </div>
                    <div class="modal-body">




                    <div class="table-responsive" id="table11">
                        <table class="table table-striped table-hover mb-0">
                            <thead class="text-center">
                            <tr>
                                <th scope="col" rowspan="2">{{i18n('Route Name')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Stations')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Number of passengers')}}</th>
                                <th scope="col" colspan="2">{{i18n('Amount')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Baggage')}}</th>
                            </tr>
                            <tr>
                                <th scope="col">Нал</th>
                                <th scope="col">Терм</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="sreport in stationReports">
                                <td>{{sreport.route_name}}</td>
                                <td>{{sreport.station_name}}</td>
                                <td>{{sreport.passengers_count}}</td>
                                <td>{{sreport.cash_amount}}</td>
                                <td>{{sreport.terminal_amount}}</td>
                                <td>{{sreport.baggage_count}}</td>
                            </tr>
                            <tr v-if="stationReports.length > 0">
                                <td><b>{{i18n('Total')}}: </b></td>
                                <td>-</td>
                                <td>{{stationReportsOneTotal.passengers}}</td>
                                <td>{{stationReportsOneTotal.amount}}</td>
                                <td>{{stationReportsOneTotal.terminalamount}}</td>
                                <td>{{stationReportsOneTotal.baggage}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
    import {ModelListSelect} from 'vue-search-select';
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";

    export default {
        name: "TransporterReports",
        components: {
            Datepicker,
            ModelListSelect,
        },
        mounted() {
            let script1 = document.createElement('script');
            script1.setAttribute('src', '/xls-export-assets/xlsx.full.min.js');
            document.head.appendChild(script1);
            let script2 = document.createElement('script');
            script2.setAttribute('src', '/xls-export-assets/fileSaver.js');
            document.head.appendChild(script2);
            let script3 = document.createElement('script');
            script3.setAttribute('src', '/xls-export-assets/fileSaver.js');
            document.head.appendChild(script3);
        },
        data() {
            return {
                fromDate: this.$moment().format('MM.DD.YYYY'),
                toDate: this.$moment().format('MM.DD.YYYY'),
                fromDateForAll: this.$moment().format('MM.DD.YYYY'),
                toDateForAll: this.$moment().format('MM.DD.YYYY'),
                dateForDaily: this.$moment().format('MM.DD.YYYY'),
                transporters: [],
                reports: [],
                stationReports: [],
                reportsDaily: [],
                reportsOneTotal: {},
                stationReportsOneTotal: {},
                reportsAllTotal: {},
                reportsAll: [],
                selectedTransporter: null,
                loading_states: {
                    list: false,
                },
            }
        },
        methods: {
            downloadXlsForAll() {
                let fileName = 'Взаиморассчеты_с_перевозчиками_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.transporterAll', {
                    fromDate: this.$moment(this.fromDateForAll),
                    toDate: this.$moment(this.toDateForAll),
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            downloadXlsForOne() {
                let fileName = 'Реестр_кассовых_ведомостей_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.transporterOne', {
                    fromDate: this.$moment(this.fromDate),
                    toDate: this.$moment(this.toDate),
                    selectedTransporter: this.selectedTransporter
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    console.log(response, response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
//alx
            downloadStationsXlsForOne() {
                let fileName = 'Реестр_кассовых_ведомостей_станции' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.transporterOne', {
                    fromDate: this.$moment(this.fromDate),
                    toDate: this.$moment(this.toDate),
                    selectedTransporter: this.selectedTransporter,
                    tripId: this.reports.map(item => item['trip_id'])
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    console.log(response, response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            downloadDailyReport() {
                let fileName = 'Отчеты_по_перевозчикам__Ежедневные_отчеты' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.download-transporters-daily', {
                    forDate: this.$moment(this.dateForDaily),
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    console.log(response, response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            getTransporters() {
                this.$api.get('transporter-reports.get-transporters').then(({data}) => {
                    this.transporters = data;
                })
            },
            getTrips() {
                this.loading_states.list = true;
                let postData = {};
                postData.fromDate = this.$moment(this.fromDate).startOf('day').format('Y-MM-DD');
                postData.toDate = this.$moment(this.toDate).endOf('day').format('Y-MM-DD');

                if (this.selectedTransporter !== null) {
                    postData.selectedTransporter = this.selectedTransporter;
                }
                this.$api.post('transporter-reports.load-trips', postData).then(({data}) => {
                    this.reports = data;

                    this.calculateOneTotal();
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
//alx
            getStantions(trip_id) {
                this.loading_states.list = true;
                let postData = {};
                postData.fromDate = this.$moment(this.fromDate).startOf('day').format('Y-MM-DD');
                postData.toDate = this.$moment(this.toDate).endOf('day').format('Y-MM-DD');

                if (this.selectedTransporter !== null) {
                    postData.selectedTransporter = this.selectedTransporter;
                }
                postData.tripId = [trip_id];
                this.$api.post('transporter-reports.load-trip-stations', postData).then(({data}) => {
                    this.stationReports = data;

                    this.stationCalculateOneTotal();
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
//alx
            getStantionsTotal() {
                this.loading_states.list = true;
                let postData = {};
                postData.fromDate = this.$moment(this.fromDate).startOf('day').format('Y-MM-DD');
                postData.toDate = this.$moment(this.toDate).endOf('day').format('Y-MM-DD');

                if (this.selectedTransporter !== null) {
                    postData.selectedTransporter = this.selectedTransporter;
                }
                postData.tripId = this.reports.map(item => item['trip_id']);
                this.$api.post('transporter-reports.load-trip-stations', postData).then(({data}) => {

                    let new_data = [];
                    let arr_routes = _.groupBy(data, 'route_name');
                    Object.keys(arr_routes).forEach((route_key, index) => {
                        let arr_stations = _.groupBy(arr_routes[route_key], 'station_name');
                        Object.keys(arr_stations).forEach((station_key, index_st) => {
                            new_data.push(
                                {
                                "route_name": route_key,
                                'station_name': station_key,
                                'passengers_count': arr_stations[station_key].reduce((sum, a) => sum + a.passengers_count, 0),
                                'cash_amount': arr_stations[station_key].reduce((sum, a) => sum + a.cash_amount, 0),
                                'terminal_amount': arr_stations[station_key].reduce((sum, a) => sum + a.terminal_amount, 0),
                                'baggage_count': arr_stations[station_key].reduce((sum, a) => sum + a.baggage_count, 0)
                                });
                        });

                    });

                    this.stationReports = new_data;

                    this.stationCalculateOneTotal();
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },

            getTransporterReports() {
                this.loading_states.list = true;
                let postData = {};
                postData.fromDate = this.$moment(this.fromDateForAll).startOf('day').format('Y-MM-DD');
                postData.toDate = this.$moment(this.toDateForAll).endOf('day').format('Y-MM-DD');
                this.$api.post('transporter-reports.load-transporters', postData).then(({data}) => {
                    this.reportsAll = data;
                    this.calculateAllTotal();
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
            getTransporterDailyReports() {
                this.loading_states.list = true;
                let postData = {};
                postData.forDate = this.$moment(this.dateForDaily).startOf('day').format('Y-MM-DD');
                this.$api.post('transporter-reports.load-transporters-daily', postData).then(({data}) => {
                    this.reportsDaily = data;
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
            printData(id) {
                let fontSize = this.$refs.printTable.style.fontSize;
                this.$refs.printTable.style.fontSize = '13.5px';
                this.displayNoneLoop = false;
                let mywindow = window.open('', 'PRINT');
                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById(id).innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close();
                mywindow.focus();
                this.$refs.printTable.style.fontSize = fontSize;

                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 1000)
            },
            calculateOneTotal() {
                this.reportsOneTotal.tripsCount = this.reports.length;
                this.reportsOneTotal.passengers = this.reports.reduce((sum, a) => sum + a.passengers_count, 0);
                this.reportsOneTotal.amount = this.reports.reduce((sum, a) => sum + a.cash_amount, 0);
                this.reportsOneTotal.terminalamount = this.reports.reduce((sum, a) => sum + a.terminal_amount, 0);
                this.reportsOneTotal.onlineamount = this.reports.reduce((sum, a) => sum + a.online_amount, 0);
                this.reportsOneTotal.totalamount = this.reports.reduce((sum, a) => sum + a.total_amount, 0);
                this.reportsOneTotal.baggage = this.reports.reduce((sum, a) => sum + a.baggage_count, 0);
            },
            stationCalculateOneTotal() {
                this.stationReportsOneTotal.passengers = this.stationReports.reduce((sum, a) => sum + a.passengers_count, 0);
                this.stationReportsOneTotal.amount = this.stationReports.reduce((sum, a) => sum + a.cash_amount, 0);
                this.stationReportsOneTotal.terminalamount = this.stationReports.reduce((sum, a) => sum + a.terminal_amount, 0);
                this.stationReportsOneTotal.baggage = this.stationReports.reduce((sum, a) => sum + a.baggage_count, 0);
            },
            calculateAllTotal() {
                this.reportsAllTotal.total_passengers = this.reportsAll.reduce((sum, a) => sum + a.passenger_count, 0);
                this.reportsAllTotal.total_sum = this.reportsAll.reduce((sum, a) => sum + a.total_amount, 0);

                this.reportsAllTotal.total_presale_passengers = this.reportsAll.reduce((sum, a) => sum + a.presale_passenger_count, 0); //alx
                this.reportsAllTotal.presale_total_sum = this.reportsAll.reduce((sum, a) => sum + a.presale_amount, 0); //alx

                this.reportsAllTotal.total_today_passengers = this.reportsAll.reduce((sum, a) => sum + a.today_passenger_count, 0); //alx
                this.reportsAllTotal.today_total_sum = this.reportsAll.reduce((sum, a) => sum + a.today_amount, 0); //alx

                this.reportsAllTotal.total_bag_sum = this.reportsAll.reduce((sum, a) => sum + a.baggage_amount, 0);
                this.reportsAllTotal.total_cash_sum = this.reportsAll.reduce((sum, a) => sum + a.cash_amount, 0);
                this.reportsAllTotal.total_term_sum = this.reportsAll.reduce((sum, a) => sum + a.terminal_amount, 0);
                this.reportsAllTotal.total_online_sum = this.reportsAll.reduce((sum, a) => sum + a.online_amount, 0);

                this.reportsAllTotal.total_tr_sum = this.reportsAll.reduce((sum, a) => sum + a.tp_amount, 0);
                this.reportsAllTotal.total_av_sum = this.reportsAll.reduce((sum, a) => sum + a.av_amount, 0);
                this.reportsAllTotal.total_tr_bag = this.reportsAll.reduce((sum, a) => sum + a.tp_baggage_amount, 0);
                this.reportsAllTotal.total_av_bag = this.reportsAll.reduce((sum, a) => sum + a.av_baggage_amount, 0);
                this.reportsAllTotal.total_tax_sum = this.reportsAll.reduce((sum, a) => sum + a.tax, 0);
                //this.reportsAllTotal.total_service_sum = this.reportsAll.reduce((sum, a) => sum + a.av_service_amout, 0);
                this.reportsAllTotal.total_service_sum = this.reportsAll.reduce((sum, a) => sum + a.av_service_amount, 0); //alx
            },
            exportToExcel() {

            },
            percentFrom(a, b) {
                return Math.round(b / a * 100);
            },
            reportMonthly(i) {
                let date = new Date();
                if (i === 1) {
                    this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
                    this.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    this.getTrips();
                } else {
                    this.fromDateForAll = new Date(date.getFullYear(), date.getMonth(), 1);
                    this.toDateForAll = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    this.getTransporterReports();
                }
            },
            reportDaily(i) {
                if (i === 1) {
                    this.fromDate = new Date();
                    this.toDate = new Date();
                    this.getTrips();
                } else {
                    this.fromDateForAll = new Date();
                    this.toDateForAll = new Date();
                    this.getTransporterReports();
                }
            }
        },
        created() {
            this.getTransporters();
        },
        filters: {
            moneyFormat(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            },
        }
    }
</script>

<style scoped>
    .custom-class {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .select-with {
        width: 28%;
    }

    .button-width {
        width: 16%;
        float: right;
    }

    div#table {
        white-space: nowrap;
    }
</style>
